<template>
  <div class="messages-view-container">
    <h1>Messages</h1>
    <div class="messages-list">
      <div v-for="doc in documents" :key="doc.id" class="message">
        <h2>From: {{ doc.name }}</h2>
        <p>
          Received at :
          {{ new Date(doc.createdAt.toDate()).toLocaleDateString() }}
        </p>
        <p>Email: {{ doc.email }}</p>
        <p>Message: {{ doc.message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import getCollection from '@/composables/getCollection';
export default {
  setup() {
    const { documents } = getCollection('messages');
    console.log('Fetched documents:', documents); // Debugging line
    return {
      documents,
    };
  },
};
</script>

<style scoped>
.messages-view-container {
  padding: 20px;
}

.messages-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.message {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  width: 350px;
  min-height: 200px;
  height: fit-content;
}

.message h2 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  font-weight: 500;
}

.message p {
  font-size: 1rem;
  margin-bottom: 1rem;
}
</style>
